module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAcElEQVR4AWOgC2D2XUQkIlfDf6IBVMNbWVU4+hgQ9rW5/WNoNJCNidA1fHDy+H3+4uekjN+XLn8KiyGs4Utl3ZeqeiADSH6bOJUIGxzcvi9a+n3ugh9LVwLdhl8DQs+X8pqPXoFY/UByKNEh4gYlAACzb+mnPm8l4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KP.png
// module id = 1184
// module chunks = 0